import { fetchActivityTypes } from '../api';
import { Env } from '@/shared/config/environment';

const state = {
  activityTypes: null,
  isLoadingActivityTypes: false,
  activityTypesError: null,
};

const mutations = {
  SET_ACTIVITY_TYPES: (state, activityTypes) => {
    state.activityTypes = activityTypes;
  },
  SET_LOADING: (state, isLoading) => {
    state.isLoadingActivityTypes = isLoading;
  },
  SET_ACTIVITY_TYPES_ERROR: (state, error) => {
    state.activityTypesError = error;
  },
};

const actions = {
  async fetchActivityTypeList({ commit, dispatch }) {
    commit('SET_ACTIVITY_TYPES', null);
    commit('SET_LOADING', true);
    commit('SET_ACTIVITY_TYPES_ERROR', null);

    try {
      const activityTypes = await fetchActivityTypes();
      commit('SET_ACTIVITY_TYPES', activityTypes);

      return activityTypes;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Помилка при завантаженні даних про активності';

      commit('SET_ACTIVITY_TYPES_ERROR', errorMessage);

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Помилка при завантаженні даних про активності',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  isLoading: (state) => state.isLoadingActivityTypes,
  isActivityTypesReady: (state) => !state.isLoadingActivityTypes && state.activityTypes !== null,

  getActivityTypesError: (state) => state.activityTypesError,
  getActivityTypes: (state) => state.activityTypes,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
